"use client";

import React from "react";
import { LinkButtonSimple } from "@/components/ui/button-simple";
import Image from "next/image";
import MarqueeScroll from "./marquee-scroll";
import config from "@/config";
import Animate from "@/components/Animate";

const brands = [
  { name: "amazon", image: "/brandLogo/b1.svg" },
  { name: "apple", image: "/brandLogo/b2.svg" },
  { name: "google", image: "/brandLogo/b3.svg" },
  { name: "roku", image: "/brandLogo/b4.svg" },
  { name: "microsoft", image: "/brandLogo/b5.svg" },
  { name: "sony", image: "/brandLogo/b6.svg" },
  { name: "meta", image: "/brandLogo/b7.svg" },
  { name: "dell", image: "/brandLogo/b8.svg" },
  { name: "lenovo", image: "/brandLogo/b9.svg" },
  { name: "amazon", image: "/brandLogo/b1.svg" },
  { name: "apple", image: "/brandLogo/b2.svg" },
  { name: "google", image: "/brandLogo/b3.svg" },
  { name: "roku", image: "/brandLogo/b4.svg" },
  { name: "microsoft", image: "/brandLogo/b5.svg" },
  { name: "sony", image: "/brandLogo/b6.svg" },
  { name: "meta", image: "/brandLogo/b7.svg" },
  { name: "dell", image: "/brandLogo/b8.svg" },
  { name: "lenovo", image: "/brandLogo/b9.svg" },
  { name: "amazon", image: "/brandLogo/b1.svg" },
  { name: "apple", image: "/brandLogo/b2.svg" },
  { name: "google", image: "/brandLogo/b3.svg" },
  { name: "roku", image: "/brandLogo/b4.svg" },
  { name: "microsoft", image: "/brandLogo/b5.svg" },
  { name: "sony", image: "/brandLogo/b6.svg" },
  { name: "meta", image: "/brandLogo/b7.svg" },
  { name: "dell", image: "/brandLogo/b8.svg" },
  { name: "lenovo", image: "/brandLogo/b9.svg" },
  { name: "amazon", image: "/brandLogo/b1.svg" },
  { name: "apple", image: "/brandLogo/b2.svg" },
  { name: "google", image: "/brandLogo/b3.svg" },
  { name: "roku", image: "/brandLogo/b4.svg" },
  { name: "microsoft", image: "/brandLogo/b5.svg" },
  { name: "sony", image: "/brandLogo/b6.svg" },
  { name: "meta", image: "/brandLogo/b7.svg" },
  { name: "dell", image: "/brandLogo/b8.svg" },
  { name: "lenovo", image: "/brandLogo/b9.svg" },
];

const Hero = () => {
  return (
    <section
      className="bg-system-obsidian pb-16 pt-12 sm:pt-16 md:pb-[3.25rem] md:pt-20"
      id="landing-hero"
    >
      <div className="landing-container">
        <Animate animation="fadeIn" delay={0.5} duration={2}>
          <div className="w-full text-center">
            <h1 className="mx-auto mb-4 max-w-[59rem] text-[2rem] font-medium leading-[1.2] tracking-tight text-system-disabled sm:text-[2.5rem] md:mb-6 md:text-[3.25rem]">
              Enterprise-Grade Inventory Management, Global Shipping, Unlimited Purchases
            </h1>
            <p className="mx-auto mb-8 max-w-[21rem] text-[17px] text-system-disabled sm:max-w-[24rem] md:max-w-[30.3rem] md:text-[19px]">
              Experience a seamless global e-commerce platform with express shipping and secure wire
              payments
            </p>

            <LinkButtonSimple
              href="#join-waitlist"
              className="h-[36px] text-sm sm:text-[15px] md:h-[42px] md:text-base"
            >
              Get early access
            </LinkButtonSimple>
            <p className="my-4 text-[13px] text-system-titanium md:my-[0.9375rem]">
              *get 10% discount on your first purchase
            </p>

            {/* hero image  */}
            <div className="relative mx-auto flex w-full justify-center py-10 md:py-20 lg:py-36">
              <picture>
                <source srcSet={`${config.CLOUDFRONT_URL}/compressed/mbp.webp`} type="image/webp" />

                <Image
                  src={`${config.CLOUDFRONT_URL}/compressed/mbp.png`}
                  alt="hero"
                  fill
                  sizes="(max-width: 767px), 1440px"
                  className="mx-auto w-full md:max-w-[1440px]"
                  priority
                />
              </picture>
            </div>

            {/* leading brands  */}
            <div>
              <p className="my-8 text-system-titanium md:my-[1.75rem]">
                Leading brands in our distribution
              </p>

              <div className="relative flex w-full gap-4 overflow-x-hidden">
                <div className="pointer-events-none absolute inset-0 z-10 flex justify-between">
                  <div className="w-40 bg-gradient-to-r from-system-obsidian to-transparent lg:w-80"></div>
                  <div className="w-40 bg-gradient-to-l from-system-obsidian to-transparent lg:w-80"></div>
                </div>

                <MarqueeScroll duration={90}>
                  {[...Array(5)]
                    .flatMap(() => brands)
                    .map((brand, index) => (
                      <Image
                        key={`${index}-${brand.name}`}
                        src={brand.image}
                        alt={brand.name}
                        width={136}
                        height={54}
                        className="h-[54px] w-auto"
                      />
                    ))}
                </MarqueeScroll>
              </div>
            </div>
          </div>
        </Animate>
      </div>
    </section>
  );
};

export default Hero;
